import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import logger from '@bingads-webui-static-legacy/instrumentation/index';
import appConfig from '@bingads-webui-component-legacy/config/index';
import { connect } from '@bingads-webui-campaign/dqb-grid-datasource-connector';
import { DataSourceStore } from '@bingads-webui-campaign/data-source-store';
import { QueryBuilderFactory } from '@bingads-webui-campaign/query-builder';
import { QueryErrorFactory } from '@bingads-webui-campaign/dqb-grid-datasource-error-handler';
import { getDataSourceConfig } from './data-fetch-config';

export function getDataSource({
  gridName,
  ...restParams
}) {
  // DFM call doesn't pass gridName, while grid call passes gridName
  // Thus, the DFM call will create a new dataSource, but the grid call will read the cache
  const Permissions = appConfig.get('Permissions');
  const { dynamic } = Permissions;
  const { AdGroupsFilterImprovementEnabled } = dynamic;
  if (gridName && !AdGroupsFilterImprovementEnabled) {
    const existingDataSource = DataSourceStore.get(gridName);
    if (existingDataSource) {
      return existingDataSource;
    }
  }

  const { AdgroupsCombineGridAndChartOdataCallEnabled } = dynamic;
  const dataFetchConfig = getDataSourceConfig({
    gridNameSource: gridName,
    ...restParams,
  });
  if (dataFetchConfig.existingDataSource) {
    return dataFetchConfig.existingDataSource;
  }
  const { featureName } = dataFetchConfig.queryBuilder.commonConfig;
  const queryBuilder = QueryBuilderFactory.make(dataFetchConfig.queryBuilder);
  const queryErrors = QueryErrorFactory.make(dataFetchConfig.dataSource);
  const dataSource = connect(
    dataFetchConfig.dataSource,
    queryBuilder,
    featureName,
    logger,
    false,
    AdgroupsCombineGridAndChartOdataCallEnabled
  );
  dataSource.queryErrors = queryErrors;
  dataSource.entity = jsdata.AdGroup;

  const { filterService } = dataFetchConfig;
  const { filterConfig } = dataFetchConfig;

  if (!AdGroupsFilterImprovementEnabled) {
    DataSourceStore.set(featureName, dataSource);
  } else {
    const cacheableObjects = {
      dataSource,
      filterService,
      filterConfig,
    };

    DataSourceStore.set(featureName, cacheableObjects);
  }
  return { dataSource, filterService, filterConfig };
}
